<template>
    <div class="dep-main">

        <!--        <div class="notification is-white" v-for="(text,index) in pinnedDataList" :key="index">-->
        <!--            <p><span class="icon"><font-awesome-icon icon="star" size="2x"/></span></p>-->
        <!--            <br>-->
        <!--            <hr>-->
        <!--        </div>-->

        <div v-if="DepartureNotamTextList && DepartureNotamTextList.WeatherText" class="notification is-white">
            <hr>
            <pre>{{DepartureNotamTextList.WeatherText}}</pre>
            <hr>
        </div>
        <div v-else-if = "Dep_ICAO && !DepartureNotamTextList.WeatherText" class="notification is-white">
            <hr>
            <p style="color: red;margin-left: 40px">  {{Dep_ICAO}} : weather data not found</p>
            <hr>
        </div>
        <div v-else-if ="!Dep_ICAO">
            <hr>
            <p style="color: red;margin-left: 40px">Notam & Weather info not found for this flight.</p>
            <hr>
        </div>

        <div class="notification is-white" v-for="(NotamInfo,idx) in NotamList" :key="idx">
            <p><span @click="favEvent(NotamInfo)" class="icon"><font-awesome-icon icon="star" size="2x"/></span></p>
            <br>
            <p><span @click="modalevent(NotamInfo)" class="icon"> <font-awesome-icon icon="search-plus" size="2x"/></span></p>
            <pre v-html="getValueWithImportantWord(NotamInfo.NotamInfo)"></pre>
<!--            <pre>-->
<!--                {{NotamInfo.NotamInfo}}-->
<!--            </pre>-->
            <hr>
        </div>

        <div class="modal" :class="{'is-active': showModalFlag}">
            <button @click="modalevent()" class="modal-close is-large" aria-label="close"></button>
            <div class="modal-background"></div>
            <div class="modal-content">
                <pre class="modal-windows">{{modaldata}}</pre>
            </div>
        </div>

    </div>
</template>

<script>

    import {mapState, /*mapActions,*/ mapMutations /*,mapGetters*/} from "vuex";
    export default {
        name: "DEP",
        props: ["id", "flight"],
        data() {
            return {
                selectedNotams: [1],
                OfpAirportICAOsByTypes:[],
                sampledata :"",
                pinnedData : "",
                pinnedDataList : [],
                modaldata :"",
                showModalFlag : false,
                WeatherText : "",
                DepartureNotamTextList :null,
                NotamList : null,
                Dep_ICAO :"",
            }
        },
        computed: {
            ...mapState("ipadmain",[/*"FKey1",*/"selectedFlightItems","EFF_Json_Data","WR_Json_Data","NotamImportantList"]),
        },

       async created() {

            this.pinnedDataList = [];

            let DepICAO = this.EFF_Json_Data.poZipMain.Dep;
            let splittedNotamTextList = this.WR_Json_Data.LIST_USED_AIRPORTS;
            this.DepartureNotamTextList = splittedNotamTextList.find(x=>x.AirportIcao == DepICAO);

            if (this.DepartureNotamTextList== undefined)
            {
                return ;
            }

            this.Dep_ICAO = this.DepartureNotamTextList.AirportIcao;
            this.NotamList = this.DepartureNotamTextList.NotamInfoList;
            this.WeatherText = this.DepartureNotamTextList.WeatherText;

       },

       methods: {

            ...mapMutations("selectednotams",["set_favNotam_data"]),

           getValueWithImportantWord(value)
           {
               var i;
               for (i = 0; i < this.NotamImportantList.length; i++) {
                   this.NotamImportantList[i]
                   value=value.replaceAll(this.NotamImportantList[i].word.toString().toUpperCase(),"<span style='color: "+this.NotamImportantList[i].color+";font-weight: '"+this.NotamImportantList[i].style+"'>"+this.NotamImportantList[i].word.toString().toUpperCase()+"</span>");
               }

               return value;
           },


           pinEvent(text) {

                this.pinnedDataList.push(text);
            },

            deletepinned(text,index)
            {
                this.pinnedDataList.splice(index,1);
            },

            favEvent(text)
            {
                this.set_favNotam_data(text);
            },

            modalevent(text)
            {
                this.showModalFlag = !this.showModalFlag;
                this.modaldata = text;
            }

        }

    }
</script>

<style scoped>
    hr {
        background-color: black;
    }

    .icon {
        cursor: pointer;
    }
    .pinned-icon{
        color: green;
    }
    .modal-windows{
        background-color: #3892bd;
        color: unset;
        font-size: 1.2rem;
        padding: unset;
        font-weight: bold;

    }
    .modal{
        position: sticky;
        background-color: #fff;
        color: #fff;
        top: 15%;
        border-radius: .25rem;
        left: 10%;
        bottom: 40%;
        width: 80%;
        height: 15%;
    }
    .modal-close{
        height: 37px;
        width: 37px;
        position: sticky;
        left: 92%;
        z-index: 999;
        background-color: #999999;
    }
    .modal-background{
        background-color: #3892bd;
    }
    .modal-content{
        padding: 1.2rem;
    }
</style>
